import download from "./download";
import axios from 'axios'

async function downloadOrganizersExcel(type: string, language: string) {
    const token = localStorage.getItem('token')
    try {
        const url = `${process.env.REACT_APP_API_URL}/admin/organizers/${type}/report?language=${language}`;
        axios({
          url: url,
          method: "GET",
          responseType: 'blob',
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response: any) => {
            download(
                response.data,
                `Organizers (${language})`,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              );
        })
      } catch (error) {
        console.error("File missing")
      }
}

export default downloadOrganizersExcel;